import sanitizeHtml from 'sanitize-html';

// richText에서 plain text만 추출하는 함수
// 주의: 브라우저 환경에서만 작동하도록 함 (DOM API 사용)
export function extractBareText(htmlContent: string) {
  if (typeof window === 'undefined') return htmlContent;
  //span, p, math-inline 태그만 남기고 나머지 태그 모두 제거
  const textWithoutTagsExceptSpanAndP = sanitizeHtml(htmlContent, {
    allowedTags: ['span', 'p', 'br', 'math-inline'],
    allowedAttributes: {
      span: ['data-latex'],
      'math-inline': ['data-latex'],
    },
  });

  // 수식 데이터를 추출하기 위해 별도 처리
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = textWithoutTagsExceptSpanAndP;

  const latexSpans = tempDiv.querySelectorAll(
    'span[data-latex], math-inline[data-latex]',
  );
  const paragraphs = tempDiv.querySelectorAll('p');
  const lineBreaks = tempDiv.querySelectorAll('br');

  //모든 p 태그 앞에 \n 추가
  paragraphs.forEach((p, index) => {
    if (index > 0) {
      const textNode = document.createTextNode('\n');
      p.parentNode?.insertBefore(textNode, p);
    }
  });

  //모든 br 태그 앞에 \n 추가
  lineBreaks.forEach(br => {
    const textNode = document.createTextNode('\n');
    br.parentNode?.insertBefore(textNode, br);
  });

  //모든 span 태그 안의 수식을 추출하여 텍스트 노드로 변환
  latexSpans.forEach(span => {
    const latexValue = span.getAttribute('data-latex');
    if (latexValue) {
      const textNode = document.createTextNode(`${latexValue}`);
      span.parentNode?.replaceChild(textNode, span);
    }
  });

  //남은 span, p 태그 전부 제거
  const finalSanitizedHtml = sanitizeHtml(tempDiv.outerHTML, {
    allowedTags: [],
    allowedAttributes: {},
  });

  return finalSanitizedHtml;
}
